"use client";
import Link from "next/link";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { navItems } from "@/lib/content";
import { site } from "@/lib/site";
import { Logo } from "@/components/Logo";
import { GithubMark } from "@/components/GithubMark";

export function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-[var(--line)] bg-[var(--surface)]/95 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center gap-4 px-4 py-3 sm:px-6">
        <Link
          href="/"
          className="inline-flex shrink-0 items-center gap-2.5 transition-opacity hover:opacity-90"
          aria-label={`${site.name} home`}
        >
          <Logo size={32} />
          <span className="font-display text-lg font-bold tracking-tight text-[var(--ink)] sm:text-xl">
            {site.name}
          </span>
        </Link>

        <nav className="ml-auto hidden items-center gap-1 sm:flex sm:gap-2" aria-label="Primary">
          {navItems.map((item) => (
            <Link
              key={item.href}
              href={item.href}
              className="rounded-lg px-2.5 py-2 text-sm font-medium text-[var(--ink-soft)] transition hover:bg-[var(--surface-deep)] hover:text-[var(--ink)] sm:px-3"
            >
              {item.label}
            </Link>
          ))}
          <a
            href={site.repoUrl}
            target="_blank"
            rel="noreferrer"
            aria-label="View source on GitHub"
            className="rounded-lg p-2 text-[var(--ink-soft)] transition hover:bg-[var(--surface-deep)] hover:text-[var(--ink)]"
          >
            <GithubMark size={18} />
          </a>
          <Link
            href="/install"
            className="rounded-lg bg-brand-700 px-3 py-2 text-sm font-semibold text-white transition hover:bg-brand-800 active:scale-[0.98] sm:px-4"
          >
            Get KinetiRx free
          </Link>
        </nav>

        <button
          className="ml-auto rounded-lg p-2 text-[var(--ink-soft)] transition hover:bg-[var(--surface-deep)] sm:hidden"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <nav className="border-t border-[var(--line)] bg-[var(--surface)] px-4 py-3 sm:hidden" aria-label="Mobile">
          <ul className="space-y-1">
            {navItems.map((item) => (
              <li key={item.href}>
                <Link
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-lg px-3 py-2.5 text-sm font-medium text-[var(--ink-soft)] hover:bg-[var(--surface-deep)]"
                >
                  {item.label}
                </Link>
              </li>
            ))}
            <li className="pt-1">
              <Link
                href="/install"
                onClick={() => setOpen(false)}
                className="block rounded-lg bg-brand-700 px-3 py-2.5 text-center text-sm font-semibold text-white"
              >
                Get KinetiRx free
              </Link>
            </li>
            <li>
              <a
                href={site.repoUrl}
                target="_blank"
                rel="noreferrer"
                className="flex items-center justify-center gap-2 rounded-lg px-3 py-2.5 text-center text-sm font-medium text-[var(--ink-soft)] hover:bg-[var(--surface-deep)]"
              >
                <GithubMark size={16} /> View on GitHub
              </a>
            </li>
          </ul>
        </nav>
      )}
    </header>
  );
}
